export default "__VITE_ASSET__b$3X52_5__"